import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { toastHelper } from '../util/toastHelper.js'

const REQUEST_URL = `${process.env.REACT_APP_REQUEST_URL}/api`
const API_VERSION = 'v2'

export const getPackages = createAsyncThunk(
	'packages/getPackages',
	async (data = {}) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/list`,
				{
					method: 'POST',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(data),
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const createPackage = createAsyncThunk(
	'packages/createPackage',
	async (data) => {
		try {
			const formData = new FormData()

			if (data.image) {
				formData.append('image', data.image)
			}

			formData.append('name', data.name)
			formData.append('description', data.description)
			formData.append('priceType', data.priceType)
			formData.append('price', data.price)

			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/create`,
				{
					method: 'POST',
					credentials: 'include',
					body: formData,
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const updatePackage = createAsyncThunk(
	'packages/updatePackage',
	async ({ id, data }) => {
		try {
			const formData = new FormData()

			if (data.image) {
				formData.append('image', data.image)
			}

			if (data.name) formData.append('name', data.name)
			if (data.description)
				formData.append('description', data.description)
			if (data.priceType) formData.append('priceType', data.priceType)
			if (data.price) formData.append('price', data.price)
			if (data.addOnsIds)
				formData.append('addOnsIds', JSON.stringify(data.addOnsIds))

			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/update/${id}`,
				{
					method: 'PUT',
					credentials: 'include',
					body: formData,
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const deletePackage = createAsyncThunk(
	'packages/deletePackage',
	async (id) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/delete/${id}`,
				{
					method: 'DELETE',
					credentials: 'include',
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const getAddOns = createAsyncThunk(
	'packages/getAddOns',
	async (data) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/addOns/list`,
				{
					method: 'POST',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(data),
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const getVendorPackages = createAsyncThunk(
	'packages/getVendorPackages',
	async (data) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/list`,
				{
					method: 'POST',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(data),
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const createAddOn = createAsyncThunk(
	'packages/createAddOn',
	async (data) => {
		try {
			const formData = new FormData()

			for (const key in data) {
				if (key === 'packageIds') {
					if (Array.isArray(data[key])) {
						formData.append(key, JSON.stringify(data[key]))
					}
				} else if (data[key]) {
					formData.append(key, data[key])
				}
			}

			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/addOns/create`,
				{
					method: 'POST',
					credentials: 'include',
					body: formData,
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const updateAddOn = createAsyncThunk(
	'packages/updateAddOn',
	async ({ id, data }) => {
		try {
			const formData = new FormData()

			for (const key in data) {
				if (key === 'packageIds') {
					if (Array.isArray(data[key])) {
						formData.append(key, JSON.stringify(data[key]))
					}
				} else if (data[key]) {
					formData.append(key, data[key])
				}
			}

			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/addOns/update/${id}`,
				{
					method: 'PUT',
					credentials: 'include',
					body: formData,
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

export const deleteAddOn = createAsyncThunk(
	'packages/deleteAddOn',
	async (id) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/packages/addOns/delete/${id}`,
				{
					method: 'DELETE',
					credentials: 'include',
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
			throw err
		}
	}
)

const initialState = {
	packages: [],
	packagesFilters: {
		page: 1,
		limit: 10,
		sortBy: 'createdAt',
		orderBy: -1,
		vendorId: null,
	},
	addOns: [],
}

const packageSlice = createSlice({
	name: 'packages',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getPackages.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					state.packages = payload.data?.packages || []
				} else {
					toastHelper(
						payload?.message || 'Failed to fetch packages',
						'error'
					)
				}
			})
			.addCase(createPackage.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					toastHelper(
						payload.message || 'Package created successfully',
						'success'
					)
					if (payload.data) {
						state.packages.push(payload.data)
					}
				} else {
					toastHelper(
						payload?.message || 'Failed to create package',
						'error'
					)
				}
			})
			.addCase(updatePackage.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					toastHelper(
						payload.message || 'Package updated successfully',
						'success'
					)
				} else {
					toastHelper(
						payload?.message || 'Failed to update package',
						'error'
					)
				}
			})

			.addCase(deletePackage.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					toastHelper(
						payload.message || 'Package deleted successfully',
						'success'
					)
				} else {
					toastHelper(
						payload?.message || 'Failed to delete package',
						'error'
					)
				}
			})

			.addCase(createAddOn.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					toastHelper(
						payload.message || 'Add-on created successfully',
						'success'
					)
				} else {
					toastHelper(
						payload?.message || 'Failed to create add-on',
						'error'
					)
				}
			})

			.addCase(getAddOns.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					state.addOns = payload.data?.packageAddOnsList || []
				} else {
					toastHelper(
						payload?.message || 'Failed to fetch add-ons',
						'error'
					)
				}
			})

			.addCase(updateAddOn.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					toastHelper(
						payload.message || 'Add-on updated successfully',
						'success'
					)
				} else {
					toastHelper(
						payload?.message || 'Failed to update add-on',
						'error'
					)
				}
			})
			.addCase(deleteAddOn.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					toastHelper(
						payload.message || 'Add-on deleted successfully',
						'success'
					)
				} else {
					toastHelper(
						payload?.message || 'Failed to delete add-on',
						'error'
					)
				}
			})
			.addCase(getVendorPackages.fulfilled, (state, { payload }) => {
				if (payload && payload.success) {
					state.vendorPackages = payload.data?.packages || []
				} else {
					toastHelper(
						payload?.message || 'Failed to fetch vendor packages',
						'error'
					)
				}
			})
	},
})

export default packageSlice.reducer
